import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="payment-cancel">
      <div className="max-w-lg text-center">
        <div className="label-eyebrow mb-4">No pressure</div>
        <h1 className="font-serif text-5xl md:text-6xl leading-[1.05] mb-6">
          Come back when you're <em className="italic">ready</em>.
        </h1>
        <p className="text-stone-600 leading-relaxed mb-10">
          Your practice is still here, waiting. Nothing was charged.
        </p>
        <div className="flex items-center justify-center gap-4">
          <Link to="/pricing" data-testid="btn-back-pricing" className="text-sm text-[hsl(var(--primary))] underline">Back to pricing</Link>
          <Link to="/" data-testid="btn-back-home" className="text-sm bg-[hsl(var(--foreground))] text-white px-6 py-3 hover:bg-[hsl(var(--primary))] transition-colors">Return home</Link>
        </div>
      </div>
    </div>
  );
}
